import _ from 'lodash';
import { APPLY_FILTERS } from '../constants';

export const applyFilters = optionsDict => ({
  type: APPLY_FILTERS,
  payload: { optionsDict },
});

export function addParameter(optionGroup) {
  const optionsArray = [];
  if (!('search' in optionGroup)) {
    _.map(optionGroup, options => {
      _.map(options.options, indOptionSet => {
        optionsArray.push(indOptionSet);
      });
    });
    const optionsDict = {};
    optionsArray.forEach(option => {
      optionsDict[option.id] = optionsDict[option.id] || [];
      if (option.true) {
        optionsDict[option.id].push(option.value);
      }
    });
    return applyFilters(optionsDict);
  }

  const optionsDict = optionGroup;
  return applyFilters(optionsDict);
}

export function addParameterAndSearch(optionGroup) {
  function combineParam(dispatch) {
    dispatch(addParameter(optionGroup));
  }
  return combineParam;
}
